import { API } from "../../config";

const readError = async (response) => {
  const payload = await response.json().catch(() => ({}));
  throw new Error(payload.detail || "Humn Ai could not complete that request");
};

export const transcribeMemory = async (audio, sessionId) => {
  const body = new FormData();
  body.append("session_id", sessionId);
  body.append("audio", audio, audio.type.includes("mp4") ? "memory.m4a" : "memory.webm");
  const response = await fetch(`${API}/memory/transcribe`, { method: "POST", body });
  if (!response.ok) return readError(response);
  return response.json();
};

export const analyzeCreatorMemory = async ({ memory, photo, sessionId, onStatus }) => {
  const body = new FormData();
  body.append("session_id", sessionId);
  body.append("memory_text", memory);
  if (photo) body.append("photo", photo);
  const response = await fetch(`${API}/memory/analyze`, { method: "POST", body, headers: { Accept: "text/event-stream" } });
  if (!response.ok) return readError(response);
  const reader = response.body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";
  let result = null;
  while (true) {
    const { done, value } = await reader.read();
    buffer += decoder.decode(value || new Uint8Array(), { stream: !done });
    const events = buffer.split("\n\n");
    buffer = events.pop() || "";
    events.forEach((event) => {
      const line = event.split("\n").find((item) => item.startsWith("data: "));
      if (!line) return;
      const payload = JSON.parse(line.slice(6));
      if (payload.type === "status") onStatus?.(payload.message);
      if (payload.type === "error") throw new Error(payload.message);
      if (payload.type === "result") result = payload.result;
    });
    if (done) break;
  }
  if (!result) throw new Error("Humn Ai could not read that vibe yet. Please try again.");
  return result;
};